import React, { useState, FC } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { getLogin } from "Slices/appState";
import { getLoginErrorText } from "Slices/appState/selectors";
import { getCognitoLoginUrl, cognitoConfig } from "Config/cognito";

import {
  SignInFormContainerStyled,
  TitleStyled,
  InputStyled,
  SubmitStyled,
  LoginErrMsgStyled,
  ForgotPasswordStyled,
  CognitoLoginButton,
} from "./styles";

type LoginProps = {
  onForgotSelected: () => void;
};

export const LoginComponent: FC<LoginProps> = ({ onForgotSelected }) => {
  const loginErrorText = useSelector(getLoginErrorText);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoginDataEmpty, setIsLoginDataEmpty] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleCognitoLogin = () => {
    // Redirect to Cognito Hosted UI
    window.location.href = getCognitoLoginUrl();
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setIsLoginDataEmpty(false); // clear out errors on each submit

    if (!email || !password) {
      setIsLoginDataEmpty(true);
      return;
    }

    dispatch(getLogin({ email, password, navigateCallBack: navigate }));
  };

  // Check if Cognito is configured
  const isCognitoConfigured = cognitoConfig.clientId && cognitoConfig.domain;

  return (
    <SignInFormContainerStyled onSubmit={handleSubmit}>
      <TitleStyled>Sign In</TitleStyled>
      {isLoginDataEmpty && (
        <LoginErrMsgStyled>Username and password required.</LoginErrMsgStyled>
      )}
      <InputStyled
        type="email"
        name="email"
        onChange={(e) => setEmail(e.currentTarget.value.toLowerCase())}
        placeholder="Email"
        value={email}
      />
      <InputStyled
        type="password"
        name="password"
        onChange={(e) => setPassword(e.currentTarget.value)}
        placeholder="Password"
        value={password}
      />
      <SubmitStyled>SUBMIT</SubmitStyled>
      {isCognitoConfigured && (
        <CognitoLoginButton type="button" onClick={handleCognitoLogin}>
          Sign in with SSO
        </CognitoLoginButton>
      )}
      <ForgotPasswordStyled onClick={onForgotSelected}>
        FORGOT PASSWORD
      </ForgotPasswordStyled>
      {loginErrorText && (
        <LoginErrMsgStyled>{loginErrorText}</LoginErrMsgStyled>
      )}
    </SignInFormContainerStyled>
  );
};
